import { Component, inject, input, output } from '@angular/core';
import { AdHocContractParams, AdHocContractService } from '../../../woo_services.module/AdHocContractService';
import { TranslationService } from '../../../woo_services.module/TranslationService';
import { AdOrganisation, CompactAgency, Period } from '../../../woo_services.module/shared-types';

@Component({
  selector: 'new-ad-hoc-contract',
  templateUrl: './new-ad-hoc-contract.component.html',
  styleUrls: ['./new-ad-hoc-contract.component.scss'],
  standalone: false,
})
export class NewAdHocContract {
  adHocContractService = inject(AdHocContractService);
  translationService = inject(TranslationService);
  agencies = input<CompactAgency[]>();
  adOrganisations = input<AdOrganisation[]>();
  onNewAdHocContract = output<AdHocContractParams>();
  onAbort = output<void>();

  discounts = this.adHocContractService.getDiscountTypes();

  period: Period;

  contract = {
    start_date: null,
    end_date: null,
    ad_organisation_id: null,
    agency_id: null,
    discounts: [],
  };

  convertDiscount = this.translationService.convertDiscount;

  newAdHocContract = (): void => {
    this.contract.ad_organisation_id = this.adOrganisations().find((org) => org.name === 'TV4').id;
    this.onNewAdHocContract.emit(this.contract);
  };

  allFieldsValid = (): boolean => {
    const dateFilled = this.contract.start_date !== null && this.contract.end_date !== null;
    const agencyFilled = this.agencies?.length > 0 ? this.contract.agency_id !== null : true;
    return this.allValidDiscountAmounts() && dateFilled && agencyFilled;
  };

  periodChanged = (event: Period): void => {
    this.contract.start_date = event.start;
    this.contract.end_date = event.end;
  };

  private allValidDiscountAmounts = () => {
    if (this.contract.discounts.length < 1) return false;
    return !this.contract.discounts.some((discount) => discount.discount_rate <= 0 || discount.discount_rate >= 1);
  };
}
